import styled from 'styled-components';

type Props = {
  value?: boolean;
  onClick?: (value: boolean) => void;
  label?: React.ReactNode;
};

const SquareCheckbox = ({ value, onClick, label }: Props) => {
  const handleClick = () => {
    onClick?.(!value);
  };

  if (value) {
    return (
      <Container onClick={handleClick}>
        <CheckedBox>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            fill='none'
          >
            <path
              d='M11.2741 20.6668C10.9184 20.6668 10.5805 20.518 10.3314 20.2576L5.29775 14.9931C4.78194 14.4536 4.78194 13.5607 5.29775 13.0212C5.81356 12.4817 6.66731 12.4817 7.18313 13.0212L11.2741 17.2998L20.4164 7.7381C20.9322 7.19863 21.786 7.19863 22.3018 7.7381C22.8176 8.27757 22.8176 9.17049 22.3018 9.70996L12.2168 20.2576C11.9678 20.518 11.6299 20.6668 11.2741 20.6668Z'
              fill='white'
            />
          </svg>
        </CheckedBox>
        {label && <div className='label'>{label}</div>}
      </Container>
    );
  }
  return (
    <Container onClick={handleClick}>
      <UnCheckedBox onClick={handleClick} />
      {label && <div className='label'>{label}</div>}
    </Container>
  );
};

export default SquareCheckbox;

const Container = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  .label {
    user-select: none;
    color: #1d2129;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const UnCheckedBox = styled.div`
  cursor: pointer;
  width: 32px;
  height: 32px;
  aspect-ratio: 1/1;
  border: 1px solid #86909c;
  border-radius: 4px;
  background-color: #f6f7fc;
  box-sizing: border-box;
  transition: all 0.3s ease;
  &:hover {
    opacity: 0.8;
  }
  user-select: none;
`;
const CheckedBox = styled.div`
  cursor: pointer;
  width: 32px;
  height: 32px;
  aspect-ratio: 1/1;
  border: 1px solid #2d6772;
  border-radius: 4px;
  background-color: #2d6772;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  &:hover {
    opacity: 0.8;
  }
  user-select: none;
`;
